module.exports = __webpack_public_path__ + "static/media/event-services-img48.2239c64f.jpg";